import ListingPage from "./ListingPage";
import { useSelector } from "react-redux";
import {
  getShowDealBanner,
  getShowDealBannerAsDiscount
} from "../../state/modules/featureToggles/selectors";

const ConnectedListingPage = inputProps => {
  const props = {
    ...inputProps,
    dealBannerEnabled: useSelector(getShowDealBanner),
    dealBannerShownAsDiscount: useSelector(getShowDealBannerAsDiscount)
  };

  return <ListingPage {...props} />;
};

export default ConnectedListingPage;
